import React, { useState, useEffect } from 'react';
import {
    Box,
    Center,
    KeyboardAvoidingView,
    ScrollView,
    View
} from "native-base";
import {
    Platform,
} from 'react-native';
import { useHeaderHeight } from '@react-navigation/elements';
import Header from './Header';
import Footer from './Footer';
import * as util from '../util/Util';
import Subscribe from './Subscribe';

const ScreenTemplate = ({
    bg="white",
    children,
    fullScreen,
    showHeader = true,
    showFooter = true,
    maxWidth = 960,
    maxContentWidth = 640 }) => {

    const [cachedWindowSize, setCachedWindowSize] = useState({
        width: 0,
        height: 0
    });

    const isLargeScreen = util.isLargeScreen();
    const isMobileDevice = util.isMobile();
    const windowSize = util.getWindowSize();
    const headerHeight = useHeaderHeight();
    const contentHeight = showFooter ? '93%' : '100%';

    useEffect(() => {
        setCachedWindowSize(windowSize);
    }, []);

    if (!isMobileDevice) {
        useEffect(() => {
            setCachedWindowSize(windowSize);
        }, [windowSize]);
    }

    let screenHeight = windowSize.height;

    if (fullScreen && showHeader) {
        screenHeight = windowSize.height - headerHeight;
    }

    return (
        // <KeyboardAvoidingView
        //     flex={1}
        //     behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
        <ScrollView flex={1}>
            <Center w={windowSize.width} bg={bg} >
                <View
                    h={cachedWindowSize.height}
                    w="100%" 
                    maxW={maxWidth}>
                    {showHeader && <Header></Header>}
                    <View h={contentHeight}>
                        <Center h="100%">
                            <Center
                                w="100%"
                                maxW={maxContentWidth}
                                h="100%"
                                justifyContent={["top", "center"]}
                            >
                                {children}
                            </Center>
                        </Center>
                    </View>
                    {showFooter && <Footer></Footer>}
                </View>
            </Center>
        </ScrollView>
        // </KeyboardAvoidingView>
    );
}

export default ScreenTemplate;